export const DEFAULT_ENABLED_CREATE_INVOICE_MODES = [
  "customer_selection",
  "automated",
  "manual",
];

export const DEFAULT_CREATE_INVOICE_MODE = "customer_selection";

export const CREATE_INVOICE_MODE_OPTIONS = [
  {
    id: "customer_selection",
    title: "Customer Selection",
    description: "Creates an invoice without choosing Stripe or manual payment up front.",
  },
  {
    id: "automated",
    title: "Stripe Invoice",
    description: "Creates a checkout-enabled invoice with a Stripe payment link.",
  },
  {
    id: "manual",
    title: "Manual Invoice",
    description: "Creates an invoice without Stripe checkout; payment must be recorded manually.",
  },
];

export const normalizeCreateInvoiceModeConfig = (rawConfig = {}) => {
  const enabledModes = Array.isArray(rawConfig?.enabledModes)
    ? DEFAULT_ENABLED_CREATE_INVOICE_MODES.filter((mode) => rawConfig.enabledModes.includes(mode))
    : DEFAULT_ENABLED_CREATE_INVOICE_MODES;

  const safeEnabledModes = enabledModes.length
    ? enabledModes
    : DEFAULT_ENABLED_CREATE_INVOICE_MODES;

  const defaultMode = safeEnabledModes.includes(rawConfig?.defaultMode)
    ? rawConfig.defaultMode
    : safeEnabledModes.includes(DEFAULT_CREATE_INVOICE_MODE)
      ? DEFAULT_CREATE_INVOICE_MODE
      : safeEnabledModes[0];

  return {
    enabledModes: safeEnabledModes,
    defaultMode,
    enableInvoiceCreationReview: rawConfig?.enableInvoiceCreationReview === true,
  };
};

export const getCreateInvoiceModeLabel = (mode) => (
  CREATE_INVOICE_MODE_OPTIONS.find((option) => option.id === mode)?.title || "Customer Selection"
);
